import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { UiFramework } from '../types'

const defaultUiFramework: UiFramework = 'legacy'

const uiFrameworkContext = createContext<UiFramework>(defaultUiFramework)

export function UiFrameworkProvider(props: PropsWithChildren<{ uiFramework?: UiFramework }>) {
  const { uiFramework } = props
  const [localUiFramework] = useState<UiFramework>(() => uiFramework ?? defaultUiFramework)

  return (
    <uiFrameworkContext.Provider value={localUiFramework}>
      {props.children}
    </uiFrameworkContext.Provider>
  )
}

export function useUiFramework() {
  return useContext(uiFrameworkContext)
}
